import { defineMessages } from 'react-intl';

export const templateCardMessages = defineMessages({
  status: {
    id: 'template-card.status',
    defaultMessage: 'Status',
    description: 'Status label',
  },
  owner: {
    id: 'template-card.owner',
    defaultMessage: 'Owner',
    description: 'Owner label',
  },
  businessUnit: {
    id: 'template-card.business-unit',
    defaultMessage: 'Business Unit',
    description: 'Business Unit label',
  },
  useAsNewProduct: {
    id: 'template-card.use-as-new-product',
    defaultMessage: 'Use as new Product',
    description: 'Use as new product button',
  },
  editTemplate: {
    id: 'template-card.edit-template',
    defaultMessage: 'Edit Tailoring Proposal',
    description: 'Edit template button',
  },
  publishTemplate: {
    id: 'template-card.publish-template',
    defaultMessage: 'Publish Tailoring Proposal',
    description: 'Publish template button',
  },
  privateTemplate: {
    id: 'template-card.private-template',
    defaultMessage: 'Set Tailoring Proposal as private',
    description: 'Private template button',
  },
  deleteTemplate: {
    id: 'template-card.delete-template',
    defaultMessage: 'Delete Tailoring Proposal',
    description: 'Delete template button',
  },
});
